import React from 'react';
import PropTypes from 'prop-types';
import { t } from 'i18next';
import {
  WidgetToolbar,
  StyledMDBDropdown,
  DropdownItem,
  StyledMDBDropdownToggle,
  StyledMDBDropdownMenu,
} from './css';
import ActionsBlack from '../../../assets/icons/ActionsBlack.svg';
import TertiaryButton from '../buttons/TertiaryButton';
import SvgIcon from '../icons/SvgIcon';

const Toolbar = (props) => {
  const {
    options, resolution, paddingicons, iconsheight,
  } = props;

  if (resolution === 'mobile') {
    return (
      <WidgetToolbar>
        <StyledMDBDropdown className="dropdown">
          <StyledMDBDropdownToggle className="border-0">
            <img src={ActionsBlack} alt="Actions" />
            <span>{t('Actions')}</span>
          </StyledMDBDropdownToggle>
          <StyledMDBDropdownMenu className="text-white bg-dark" basic right>
            <>
              {options.map((option, index) => (
                <DropdownItem key={`mobile-toolbar-action-${index}`} onClick={option.action}>
                  {(option.icon) ? <SvgIcon icon={option.icon} className="mr-2" fill="black" /> : null}
                  {option.label}
                </DropdownItem>
              ))}
            </>
          </StyledMDBDropdownMenu>
        </StyledMDBDropdown>
      </WidgetToolbar>
    );
  }

  if (resolution === 'desktop') {
    return (
      <WidgetToolbar>
        {options.map((option, index) => (
          <TertiaryButton
            key={`desktop-toolbar-action-${index}`}
            label={option.label}
            onClick={option.action}
            size="small"
            showArrow={false}
            icon={option.icon}
            isIconLeftPosition
            paddingicons={paddingicons}
            iconsheight={iconsheight}
          />
        ))}
      </WidgetToolbar>
    );
  }

  return null;
};

Toolbar.propTypes = {
  options: PropTypes.array,
  resolution: PropTypes.string,
  paddingicons: PropTypes.string,
  iconsheight: PropTypes.string,
};

export default Toolbar;
